



















import Vue from 'vue'

export default Vue.extend({
  name: 'CCalendarSearchPreview',
  props: {
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    }
  }
})
